// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9e0ef52c","239":"a190be4c","453":"29a15e43","455":"f064de3e"}[chunkId] + ".chunk.js";
};